// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import categoryItemSharedStyles from "@pace/App/SharedStyles/categoryItemSharedStyles";
import { categoryListStyles } from "@pace/Overrides/Widgets/Category/CategoryList";
import { xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

categoryListStyles.container = {
    ...categoryItemSharedStyles.container,
};
categoryListStyles.categoryListLeftGridItem = {
    width: [12, 12, 12, 3, 3],
    css: css`
        flex-direction: column;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
categoryListStyles.categoryListRightGridItem = {
    width: [12, 12, 12, 9, 9],
};

categoryListStyles.categoryImageItem = {
    ...categoryItemSharedStyles.categoryImageItem,
};

categoryListStyles.categoryImage = {
    ...categoryItemSharedStyles.categoryImage,
};
categoryListStyles.innerContainer = {
    ...categoryItemSharedStyles.innerContainer,
};

categoryListStyles.categoryItem = {
    ...categoryItemSharedStyles.categoryItem,
};

categoryListStyles.categoryName = {
    ...categoryItemSharedStyles.subCategoryNameText,
};
categoryListStyles.categoryListHeaderGridItem = {
    ...categoryItemSharedStyles.categoryListHeaderGridItem,
};
categoryListStyles.categoryListHeaderText = {
    ...categoryItemSharedStyles.categoryListHeader,
};
categoryListStyles.subCategoryNameLinkItem = {
    ...categoryItemSharedStyles.subCategoryNameLinkItem,
};
categoryListStyles.subCategoryNameLink = {
    ...categoryItemSharedStyles.subCategoryNameLink,
};

categoryListStyles.accordionSection = {
    ...categoryItemSharedStyles.accordionSection,
};
categoryListStyles.subCategoryWrapper = {
    ...categoryItemSharedStyles.subCategoryWrapper,
};
categoryListStyles.accordionWrapper = {
    ...categoryItemSharedStyles.accordionWrapper,
};

categoryListStyles.categoryDropdownGridItem = {
    ...categoryItemSharedStyles.categoryDropdownGridItem,
};

categoryListStyles.categoryFiltersHeaderText = {
    ...categoryItemSharedStyles.categoryFiltersHeaderText,
};
